import styled from 'styled-components'

export const Container = styled.div`
  height: 100%;
  position: relative;
  display: flex;
  flex-direction: column;
  row-gap: 21px;
`

export const Grid = styled.div`
  flex: 1 1 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`

export const Row = styled.div`
  display: flex;
  column-gap: 10px;
  align-items: center;
`

export const YAxisRectange = styled.div`
  height: 10px;
  width: 31px;
  border-radius: 20px;
  background-color: #edeff3;
`

export const Line = styled.div`
  width: 100%;
  height: 0;
  border-top: 1px dashed #e0e3eb;
`

export const XAxis = styled.div`
  margin-left: 41px;
  display: flex;
  justify-content: space-between;
`

export const XAxisDot = styled.div`
  width: 10px;
  height: 10px;
  border-radius: 20px;
  background-color: #edeff3;
`

export const Average = styled.div`
  margin-left: 41px;
  height: 25px;
  border-radius: 5px;
  background: #edeff3;
`

export const NoDataMessage = styled.div`
  position: absolute;
  left: calc(50% - 15px);
  top: 50%;
  transform: translate(-50%, -50%);
  padding: 25px 30px;
  display: flex;
  column-gap: 10px;
  align-items: center;
  border-radius: 10px;
  border: 1px solid #e0e3eb;
  background-color: #f9fafb;

  color: ${({ theme }) => theme.palette.black[60]};
  font-size: 16px;
  line-height: 24px;

  & svg {
    flex: 1 0 auto;
  }
`
